export default __webpack_public_path__ + "static/media/mg.33507485.svg";